import mixins from 'synergycms_core/src/less/mixins';

export default {
  defaultStyle: {
    display: 'none',
    position: 'fixed',
    left: '0',
    right: '0',
    top: '0',
    bottom: '100%',
    height: '100%',
    background: '#fff',
    zIndex: '600',
    overflow: 'auto',
    ...mixins.transition('bottom 1s'),
    '@media (min-width: 1001px)': {
      position: 'absolute',
      top: '100%',
      left: '0',
      right: '0',
      bottom: 'auto',
      overflow: 'auto',
      height: 'auto',
      zIndex: '400',
      maxHeight:'calc(100vh - 142px)',
      ...mixins.boxShadow('0 10px 13px -2px rgba(0, 0, 0, 0.58),inset -5px 6px 8px -10px rgb(0 0 0 / 58%)'),
    }
  },
  selected: {
    ...mixins.transition('.5s'),
    display: 'block'
  },
  controls: {
    borderTop: '1px solid #d8d8d8',
    ...mixins.boxShadow('none'),
    padding: '15px 20px 15px',
    ...mixins.transition('bottom 1s'),
    position: 'fixed',
    bottom: '0',
    left: '0',
    right: '0',
    background: '#fff',
    '@media (min-width: 1001px)': {
      marginBottom: '20px',
      position: 'static'
    }
  },
  filterHeaderTitle: {
    fontSize: '18px',
    fontWeight:500,
    padding: '11px 45px 11px 20px',
    borderBottom: '1px solid #d8d8d8',
    position: 'sticky',
    top:0,
    zIndex:1,
    backgroundColor:'#fff',
    display: 'block',
    '&:lang(ar)':{
      paddingRight:'20px',
      paddingLeft:'45px'
    }
  },
  filterContainer:{
    '@global button': {
      position: 'fixed',
      zIndex:2,
      top:'12px',
      marginTop:'0'
    },
    paddingBottom:'100px',
    '@media (min-width:1001px)':{
      padding:0
    }
  }
};
